import { Injector } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { FormlyView } from '../Data/FormlyView';
import { BaseNode } from './BaseNode';
import { ListColumn } from '../Data/ListColumn';
import { SearchField } from '../SearchField';
import { FormlyUtil } from '../FormlyUtil';

export class QueryFieldsNode extends BaseNode {
  originalInfo: any;
  constructor(injector: Injector, fields: FormlyFieldConfig[], model: any) {
    const newModel: any = {...model};
    fields.forEach((f: any) => {
      if (f.props!['defaultSelection'] === true) {
        newModel[String(f.key)] = true;
      }
      if (f.props!['defaultSelection'] === false) {
        newModel[String(f.key)] = false;
      }
    });

    const cloned = FormlyUtil.cloneFormlyView(fields, newModel);

    super(
      injector,
      new FormlyView(cloned.form, cloned.fields, cloned.model),
      'Fields',
    );

    this.originalInfo = cloned;
  }

  getListItem(): any[] {
    return [this.label];
  }

  getFieldsToRetrieve(): string {
    const fieldsToRetrieve: SearchField = new SearchField();
    const arrayModel = Object.entries(this.data.model).map(([key, value]) => {
      return { key, value };
    });

    arrayModel.forEach((modelItem: any) => {
      if (modelItem.value == true) {
        const foundField = this.data.fields.find(
          (fieldItem: any) => fieldItem.key == modelItem.key,
        );
        fieldsToRetrieve.addField(foundField.key, foundField.props['label']);
      }
    });

    if (fieldsToRetrieve.getFieldCount() < 2) {
      // only num field is retrieved
      fieldsToRetrieve.clear();
      arrayModel.forEach((modelItem: any) => {
        const foundField = this.data.fields.find(
          (fieldItem: any) => fieldItem.key == modelItem.key,
        );
        if (foundField.props['defaultSelection'] === true) {
          // is default selection field
          fieldsToRetrieve.addField(foundField.key, foundField.props['label']);
        }
      });
    }

    return fieldsToRetrieve.getJSONString();
  }

  getFieldsToShow(): ListColumn[] {
    let fieldsToShow: ListColumn[] = [];

    const arrayModel = Object.entries(this.data.model).map(([key, value]) => {
      return { key, value };
    });

    arrayModel.forEach((modelItem: any) => {
      if (modelItem.value == true) {
        const foundField = this.data.fields.find(
          (fieldItem: any) => fieldItem.key == modelItem.key,
        );
        fieldsToShow.push(
          new ListColumn(
            foundField.props['label'],
            foundField.props['fieldDataType'],
            foundField.key,
            foundField.props['lookup'],
          ),
        );
      }
    });

    if (fieldsToShow.length < 2) {
      // only num field is retrieved
      fieldsToShow = [];
      arrayModel.forEach((modelItem: any) => {
        const foundField = this.data.fields.find(
          (fieldItem: any) => fieldItem.key == modelItem.key,
        );
        if (foundField.props['defaultSelection'] === true) {
          // is default selection field
          fieldsToShow.push(
            new ListColumn(
              foundField.props['label'],
              foundField.props['fieldDataType'],
              foundField.key,
              foundField.props['lookup'],
            ),
          );
        }
      });
    }

    return fieldsToShow;
  }

  override cloneNode(newParent: BaseNode): BaseNode {
    const clonedNode = new QueryFieldsNode(this.ioc!, this.originalInfo.fields,this.originalInfo.model);
    clonedNode.parent = newParent;
    return clonedNode;
  }

}
